import {z} from 'zod';

import {
  FinancialProductType,
  FinancialProductTypeSchema,
  FinancingCompositionSceneSchema,
} from '@dms/api/shared';

// Data-field tokens a financing promo photo text layer may reference as `{{KEY}}`; the BE
// substitutes them per vehicle when rendering.
export type FinancingFieldResponseBody = {
  key: string;
  label: string;
  // The value the financing preview without a vehicle renders for this field. Null when the field
  // has none; missing from a BE that does not send samples.
  sample?: string | null;
};
export type GetFinancingFieldsApiResponse = /** status 200  */ FinancingFieldResponseBody[];
export type GetFinancingFieldsApiArg = {
  financialProductType: FinancialProductType;
};

// Financing-aware render of a promo photo scene: the photo slot and `{{KEY}}` tokens are filled
// with sample data, or with the vehicle's N-th photo and real offer values when saleVehicleId is
// given. Business problems (no offer, missing photo) come back as warnings, never as 400.
export const FinancingPromoPreviewRequestBodySchema = z.object({
  scene: FinancingCompositionSceneSchema,
  financialProductType: FinancialProductTypeSchema,
  saleVehicleId: z.string().nullable().optional(),
  sourcePhotoIndex: z.number().int().min(1).nullable().optional(),
});
export type FinancingPromoPreviewRequestBody = z.infer<
  typeof FinancingPromoPreviewRequestBodySchema
>;
export type FinancingPromoPreviewApiArg = {
  financingPromoPreviewRequestBody: FinancingPromoPreviewRequestBody;
};

// Resets the promo photo order in every sale vehicle back to the catalog position. The vehicle
// counterpart (`/promotional-photo/vehicle/reset-positions-to-all-vehicles`) only touches legacy
// vehicle links, which the gallery no longer reads.
export type ResetPositionsInAllSaleVehiclesRequestBody = {
  promotionalPhotoIds: string[];
};
export type ResetPositionsInAllSaleVehiclesApiArg = {
  resetPositionsInAllSaleVehiclesRequestBody: ResetPositionsInAllSaleVehiclesRequestBody;
};
export type ResetPositionsInAllSaleVehiclesApiResponse = unknown;
